import {
  Flex,
  HorizontalSpacing,
  IconInfo,
  Tag,
  Typography,
} from '@banhala/ui-kit';
import type { MarketDetail } from 'shared/src/api';
import { IconButton } from './IconButton';
import { MarketProfileImage } from './MarketProfileImage';
import { MumulLiveStatusText } from './MumulLiveStatusText';
import type { MumulLiveStatusDisplay } from '../constants/mumulLiveStatusDisplay';

type Market = MarketDetail['market'];

type Props = {
  market: Market;
  /** 무물라이브 상태 표시 정보. null 이면 기본(DEFAULT) 레이아웃. */
  statusDisplay: MumulLiveStatusDisplay | null;
  onPressMarketInfo: () => void;
  /** 프로필 이미지 클릭 (상태별 액션). */
  onPressProfile: () => void;
};

/** 공식 / 마켓 타입 태그 묶음. */
const MarketTags = ({ market }: { market: Market }) => (
  <>
    {market.is_official && (
      <Tag color="blue" size="xsmall" type="secondary">
        공식
      </Tag>
    )}
    <Tag color="gray" size="xsmall" type="secondary">
      {market.market_type.name}
    </Tag>
  </>
);

/**
 * 마켓홈 상단 프로필 헤더.
 * - 무물라이브 상태가 있으면: 마켓명 + 태그를 한 줄(row)로, 아래에 상태 텍스트
 * - 기본(DEFAULT): 태그가 위, 마켓명이 아래(column)
 */
export const MarketProfileHeader = ({
  market,
  statusDisplay,
  onPressMarketInfo,
  onPressProfile,
}: Props) => {
  return (
    <Flex.Row padding={{ vertical: 2 }} alignItems={'center'}>
      <MarketProfileImage
        uri={market.image}
        ringColor={statusDisplay?.ringColor ?? null}
        onPress={onPressProfile}
      />
      <HorizontalSpacing size={10} />
      {/* 마켓정보 는 컬럼 형제로 두고 top_side 를 가운데 정렬(Figma 기준) */}
      <Flex flex={1} gap={4}>
        {statusDisplay != null ? (
          <>
            <Flex.Row gap={4} alignItems={'center'}>
              <Typography type={'h5'} numberOfLines={1}>
                {market.name}
              </Typography>
              <MarketTags market={market} />
            </Flex.Row>
            <MumulLiveStatusText
              display={statusDisplay}
              onPress={onPressProfile}
            />
          </>
        ) : (
          <>
            <Flex.Row gap={8} alignItems={'center'}>
              <MarketTags market={market} />
            </Flex.Row>
            <Typography type={'h5'}>{market.name}</Typography>
          </>
        )}
      </Flex>
      {!market.is_exited && (
        <IconButton
          icon={<IconInfo />}
          onPress={onPressMarketInfo}
          typographyType={'body5'}
          label={'마켓정보'}
        />
      )}
    </Flex.Row>
  );
};
